<template>
    <div class="rcProgress">
        <div :style="{ height: height + 'px'}"
             class="rcProgress-item"></div>
    </div>
</template>

<script>
export default {
    name: 'rcProgress',
    props: ['value', 'height']
}
</script>

<style lang="less" scoped>
.rcProgress {
    position: relative;
    width: 30px;
    height: 95px;
    background: #f5f6f7;
    cursor: pointer;
    .rcProgress-item {
        position: absolute;
        bottom: 0;
        width: 100%;
        background: #418bcc;
    }
}
</style>
